import { defineComponent as _defineComponent } from 'vue'
import HeaderComponent from '@/components/HeaderComponent.vue';
import FlashySection from './components/FlashySection.vue';
import ProductsSection from './components/ProductsSection.vue';
import { useProductsStore } from '@/store/products_store';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props, { expose: __expose }) {
  __expose();

const productsStore = useProductsStore();

onMounted(async () => {
  await productsStore.fetchProducts(true);
});

const productsSection = ref<InstanceType<typeof ProductsSection> | null>(null);


const __returned__ = { productsStore, productsSection, HeaderComponent, FlashySection, ProductsSection }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})